import React, { Suspense, lazy } from 'react';
import { useAuth } from 'oidc-react';
import { withRouter, Switch, Route, Redirect, RouteProps } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

/* loader component for Suspense*/
import PageLoader from './components/Common/PageLoader';
import Base from './components/Layout/Base';
// import Sockets from './components/Layout/Sockets';
// import { REACT_APP_SOCKETS } from './AppConfig';

/* Used to render a lazy component with react-router */
// const useQuery = () => new URLSearchParams(useLocation().search);
// const reload = () => window.location.reload();
const waitFor = (Tag: React.LazyExoticComponent<any>) => (props: any) => <Tag {...props} />;

const Info = lazy(() => import('./components/Elements/Info'));

const NotLoggedIn = lazy(() => import('./components/Layout/NotLoggedIn'));

const Overview = lazy(() => import('./components/Overview/Overview'));
const Fields = lazy(() => import('./components/Fields/Fields'));


// List of routes that uses the page layout
// listed here to Switch between layouts
// depending on the current pathname
// const listofPages: Array<string> = [
//     /* See full project for reference */
// ];

const Routes = ({ location }: RouteProps) => {
    console.log('location', location);
    const currentKey = location!.pathname.split('/')[1] || '/';
    const timeout = { enter: 500, exit: 500 };
    const auth = useAuth();
    // Animations supported
    //      'rag-fadeIn'
    //      'rag-fadeInRight'
    //      'rag-fadeInLeft'

    const animationName = 'rag-fadeIn'

    if (auth && auth.userData) {
        console.log('option 1 - user is authenticated');
        console.log(auth);
        return (
            // Layout component wrapper
            <Base>
                {/* <Sockets url={REACT_APP_SOCKETS}> */}
                    <TransitionGroup>
                        <CSSTransition key={currentKey} timeout={timeout} classNames={animationName} exit={false}>
                            <div>
                                <Suspense fallback={<PageLoader />}>
                                    <Switch location={location}>
                                        <Route path="/info" component={waitFor(Info)} />

                                        <Route path="/overview" component={waitFor(Overview)} />
                                        <Route path="/fields" component={waitFor(Fields)} />

                                        <Redirect to="/fields" />
                                    </Switch>
                                </Suspense>
                            </div>
                        </CSSTransition>
                    </TransitionGroup>
                {/* </Sockets> */}
            </Base>
        );
    } else {
        console.log('option 2 - user is not authenticated');
        console.log('auth', auth);
        return (
            // Layout component wrapper
            <Base>
                <TransitionGroup>
                    <CSSTransition key={currentKey} timeout={timeout} classNames={animationName} exit={false}>
                        <div>
                            <Suspense fallback={<PageLoader />}>
                                <Switch location={location}>
                                    <Route path="/info" component={NotLoggedIn} />
                                </Switch>
                            </Suspense>
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            </Base>
        )
    }
}

export default withRouter(Routes);
